<template>
	<v-container class="mx-auto">
		<v-layout row wrap align-center>
			<v-card class="mx-auto outer-container" width="100%" max-height="100%">
				<v-row>
					<v-col class="col-md-6 pa-5">
						<div class="mx-4">
							<h4 class="mb-2 mt-4">About Simplelearn</h4>
							<v-subheader class="ml-0 pl-0 mt-2">Background</v-subheader>
							<div class="font-under-normal">
								Simplelearn is an e-learning platform targetted towards African
								countries. Here students can learn various topics and attempt
								quizzes to develop their literacy and numeracy skills.
							</div>

							<v-subheader class="ml-0 pl-0 mt-2">Creator</v-subheader>
							<div class="font-under-normal">
								Enoch Banjo. <br />
								MSc Software Engineering and Cyber Security,<br />De Montfort
								University.
							</div>

							<v-subheader class="ml-0 pl-0 mt-2">Project Info</v-subheader>
							<div class="font-under-normal">
								Title: Supporting the Educational system in developing countries
								using Frugal development<br /><br />
								Supervised by Dr. Neil McBride.
							</div>

							<h4 class="mt-5">End User Licence Agreement</h4>
							<v-subheader class="ml-0 pl-0 mt-2">What to know</v-subheader>
							<div class="font-under-normal">
								This is an agreement between you and Simplelearn. By using this
								software, you are agreeing to these terms.
							</div>

							<template>
								<div class="text-left pt-2">
									<v-bottom-sheet
										v-model="sheet"
										inset
										width="95vw"
										max-width="800px"
										style="border-radius: 10px !important"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												:color="theme.primary"
												dark
												v-bind="attrs"
												v-on="on"
												text
												class="text-capitalize"
											>
												Read EULA
												<v-icon size="20" class="ml-2">mdi-book</v-icon>
											</v-btn>
										</template>
										<v-sheet
											class="text-center rounded-top"
											:style="{
												'background-color': theme.dark
													? theme.secondary
													: 'white',
											}"
											height="90vh"
										>
											<v-btn
												class="py-6 text-capitalize"
												text
												:color="theme.accent"
												@click="sheet = !sheet"
												width="100%"
												>close
												<v-icon size="20" class="ml-2"
													>mdi-chevron-down</v-icon
												></v-btn
											>

											<div class="mb-3">
												<v-card
													class="font-under-normal rounded-top pa-4 eula-alt text-left"
													elevation="2"
													:class="theme.dark && 'col-white'"
													:style="{
														'background-color': theme.dark
															? theme.secondary
															: 'white',
													}"
												>
													This End-User License Agreement ("EULA") is a legal
													agreement between you and Simplelearn<br /><br />
													This EULA agreement governs your acquisition and use
													of our Simplelearn software ("Software") directly from
													Simplelearn or indirectly through a Simplelearn
													authorized reseller or distributor (a "Reseller").<br /><br />Please
													read this EULA agreement carefully before completing
													the installation process and using the Simplelearn
													software. It provides a license to use the Simplelearn
													software and contains warranty information and
													liability disclaimers.<br /><br />If you register for
													a free trial of the Simplelearn software, this EULA
													agreement will also govern that trial. By clicking
													"accept" or installing and/or using the Simplelearn
													software, you are confirming your acceptance of the
													Software and agreeing to become bound by the terms of
													this EULA agreement.<br /><br />If you are entering
													into this EULA agreement on behalf of a company or
													other legal entity, you represent that you have the
													authority to bind such entity and its affiliates to
													these terms and conditions. If you do not have such
													authority or if you do not agree with the terms and
													conditions of this EULA agreement, do not install or
													use the Software, and you must not accept this EULA
													agreement.<br /><br />This EULA agreement shall apply
													only to the Software supplied by Simplelearn herewith
													regardless of whether other software is referred to or
													described herein. The terms also apply to any
													Simplelearn updates, supplements, Internet-based
													services, and support services for the Software,
													unless other terms accompany those items on delivery.
													If so, those terms apply. This EULA was created by
													EULA Template for Simplelearn.<br /><br /><strong
														>License Grant</strong
													>
													<br /><br />
													Simplelearn hereby grants you a personal,
													non-transferable, non-exclusive licence to use the
													Simplelearn software on your devices in accordance
													with the terms of this EULA agreement.<br /><br />
													You are permitted to load the Simplelearn software
													(for example a PC, laptop, mobile or tablet) under
													your control. You are responsible for ensuring your
													device meets the minimum requirements of the
													Simplelearn software.<br /><br />You are not permitted
													to:
													<li>
														Edit, alter, modify, adapt, translate or otherwise
														change the whole or any part of the Software nor
														permit the whole or any part of the Software to be
														combined with or become incorporated in any other
														software, nor decompile, disassemble or reverse
														engineer the Software or attempt to do any such
														things
													</li>
													<li>
														Reproduce, copy, distribute, resell or otherwise use
														the Software for any commercial purpose
													</li>
													<li>
														Allow any third party to use the Software on behalf
														of or for the benefit of any third party
													</li>
													<li>
														Use the Software in any way which breaches any
														applicable local, national or international law
													</li>
													<li>
														Use the Software for any purpose that Simplelearn
														considers is a breach of this EULA agreement
													</li>
													<br /><br />
													<strong>Intellectual Property and Ownership</strong
													><br /><br />
													Simplelearn shall at all times retain ownership of the
													Software as originally downloaded by you and all
													subsequent downloads of the Software by you. The
													Software (and the copyright, and other intellectual
													property rights of whatever nature in the Software,
													including any modifications made thereto) are and
													shall remain the property of Simplelearn.<br /><br />Simplelearn
													reserves the right to grant licences to use the
													Software to third parties.<br /><br /><strong
														>Termination</strong
													><br /><br />
													This EULA agreement is effective from the date you
													first use the Software and shall continue until
													terminated. You may terminate it at any time upon
													written notice to Simplelearn.<br /><br />It will also
													terminate immediately if you fail to comply with any
													term of this EULA agreement. Upon such termination,
													the licenses granted by this EULA agreement will
													immediately terminate and you agree to stop all access
													and use of the Software. The provisions that by their
													nature continue and survive will survive any
													termination of this EULA agreement.<br /><br /><strong
														>Governing Law</strong
													><br /><br />This EULA agreement, and any dispute
													arising out of or in connection with this EULA
													agreement, shall be governed by and construed in
													accordance with the laws of gb.
												</v-card>
											</div>
										</v-sheet>
									</v-bottom-sheet>
								</div>
							</template>
						</div>
					</v-col>
					<v-col
						class="col-md-6 col-sm-12 pa-0 ma-0 pl-n5 ml-n3 d-none d-md-block"
						align="center"
						justify="center"
						:elevation="10"
						:style="{ 'background-color': theme.primary }"
					>
						<v-container fill-height fluid>
							<v-row align="center" justify="center">
								<v-col>
									<v-hover>
										<template v-slot="{ hover }">
											<div
												:class="`elevation-${hover ? 24 : 6}`"
												class="transition-swing logo-holder"
											>
												<v-card class="logo-holder" elevation="10"
													><h4
														:style="{
															color: theme.dark ? theme.accent : theme.primary,
														}"
														class="logo"
													>
														Simplelearn
													</h4></v-card
												>
											</div>
										</template>
									</v-hover>
								</v-col>
							</v-row>
						</v-container>
					</v-col>
				</v-row>
			</v-card>
		</v-layout>
	</v-container>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'About',

	data: () => ({
		sheet: false,
	}),

	methods: {
		...mapMutations([]),
	},

	mounted() {},

	computed: {
		...mapGetters(['theme']),
	},
}
</script>

<style scoped>
::-webkit-scrollbar {
	width: 0px;
	background: transparent;
}
.eula {
	max-height: 420px;
	overflow: scroll;
}
.eula-alt {
	overflow: scroll;
	max-height: 85vh;
}
.logo-holder {
	width: 150px;
	height: 150px;
}
.logo {
	padding-top: 65px;
}
.v-sheet.v-card {
	border-radius: 0 !important;
}
</style>
